import MediaHero from "./components/MediaHero";
import MediaGrid from "@/pages/media-coverage/components/MediaGrid";
import NewsSubscribe from "@/pages/news/components/NewsSubscribe";

export default function MediaPage() {
  return (
    <main className="min-h-screen">
      <title>Media Center | Textile Innovation Exchange</title>
      <meta
        name="description"
        content="Latest news, press coverage, and media updates from Textile Innovation Exchange and partner outlets across Bangladesh's textile sector."
      />
      <meta
        property="og:title"
        content="Media Center | Textile Innovation Exchange"
      />
      <meta
        property="og:description"
        content="News, press coverage, and media updates from TIE across Bangladeshi media outlets."
      />
      <meta
        property="og:image"
        content="https://readdy.ai/api/search-image?query=Professional%20news%20and%20media%20themed%20social%20media%20preview%20card%20for%20Textile%20Innovation%20Exchange%2C%20deep%20navy%20blue%20background%20with%20elegant%20teal%20and%20warm%20gold%20accents%2C%20newspaper%20headlines%20and%20press%20coverage%20elements%20subtly%20integrated%2C%20modern%20corporate%20journalism%20aesthetic%2C%20clean%20typography%20space%2C%20high%20contrast%2C%20no%20people%2C%20landscape%20orientation&width=1200&height=630&seq=tie-media-og&orientation=landscape"
      />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content="https://textileinnovationexchange.com/media" />
      <meta name="twitter:title" content="Media Center | Textile Innovation Exchange" />
      <meta
        name="twitter:description"
        content="News, press coverage, and media updates from TIE across Bangladeshi media outlets."
      />
      <meta
        name="twitter:image"
        content="https://readdy.ai/api/search-image?query=Professional%20news%20and%20media%20themed%20social%20media%20preview%20card%20for%20Textile%20Innovation%20Exchange%2C%20deep%20navy%20blue%20background%20with%20elegant%20teal%20and%20warm%20gold%20accents%2C%20newspaper%20headlines%20and%20press%20coverage%20elements%20subtly%20integrated%2C%20modern%20corporate%20journalism%20aesthetic%2C%20clean%20typography%20space%2C%20high%20contrast%2C%20no%20people%2C%20landscape%20orientation&width=1200&height=630&seq=tie-media-og&orientation=landscape"
      />
      <MediaHero />
      <div id="media-grid">
        <MediaGrid />
      </div>
      <NewsSubscribe />
    </main>
  );
}